// extracted by mini-css-extract-plugin
export default {"rowDragging":"styles_rowDragging__x9BwU","dragVisible":"styles_dragVisible__+eN1P","menuIcon":"styles_menuIcon__g7zuL","tableWrapper":"styles_tableWrapper__ReroL"};